import { Component, Input, OnInit } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { IBaryInput } from 'models/bary-input';
import { CommonModule } from '@angular/common';
import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';

@Component({
  selector: 'jhi-bary-input-textarea',
  templateUrl: './bary-input-textarea.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective],
  styleUrls: ['./bary-input-textarea.component.scss'],
})
export class BaryInputTextareaComponent implements IBaryInput, OnInit {
  @Input() id = '';
  @Input() placeholder?: string;
  @Input() label: string | undefined;
  @Input() icon: string | undefined;
  @Input() name: string | undefined;
  @Input() disabled = false;
  @Input() rows = 3;
  @Input() maxLength = 350;

  @Input() control = new FormControl('');

  ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
    this.control.addValidators([Validators.pattern('[^|]*')]);
  }
}
